var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafeheroBeneftisBg = function SvgSafeheroBeneftisBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 320,
    viewBox: "0 0 100% 100%"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "safehero-beneftis-bg_svg__b",
    cx: 0.5,
    cy: 0.5,
    r: 0.515,
    gradientTransform: "matrix(1 0 0 1.629 0 -.315)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7abfac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b5c71",
    stopOpacity: 0.847
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safehero-beneftis-bg_svg__a",
    x1: 1,
    x2: 0.012,
    y1: 0.107,
    y2: 0.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b5c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7abfac",
    stopOpacity: 0.604
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 320,
    fill: "url(#safehero-beneftis-bg_svg__a)",
    "data-name": "Rechteck 15006",
    opacity: 0.297,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 320,
    fill: "url(#safehero-beneftis-bg_svg__b)",
    "data-name": "Rechteck 15009",
    opacity: 0.297,
    rx: 3
  }))));
};
export default SvgSafeheroBeneftisBg;